module.exports = __webpack_public_path__ + "static/04-bb230dc0a47af1026cd3e4fb3ff7f6a9.jpg";